import { PATHS } from '@belong/common';
import { Image, Link, Text } from '@belong/ui';
import clsx from 'clsx';
import { HOMEOWNERS_STRINGS as STRINGS } from '../../../../homeowners.strings';
import { CoverCardScrollIds } from '../gttl-cover/gttl-cover';
import css from './gttl-residents-love.module.css';

const webmVideoSrc =
  'https://belong-consumer-assets.s3.us-west-1.amazonaws.com/gttl/lp_gtr_video_phone.webm';
const mp4VideoSrc =
  'https://belong-consumer-assets.s3.us-west-1.amazonaws.com/gttl/lp_gtr_video_phone.mp4';

export function GttlResidentsLove() {
  return (
    <div
      id={CoverCardScrollIds.ResidentsLove}
      className="bg-darker-navy pt-5xl container relative flex flex-col-reverse items-center justify-center overflow-hidden text-white md:w-full md:flex-row md:pt-0"
    >
      <div className={clsx(css.imageContainer)}>
        {webmVideoSrc ? (
          <video
            width="100%"
            height="100%"
            autoPlay
            controls={false}
            muted={true}
            loop
            className={css.video}
            {...{
              playsInline: true,
              'webkit-playsinline': 1,
              'x5-playsinline': 1,
            }}
          >
            <source src={webmVideoSrc} type="video/webm" />
            <source src={mp4VideoSrc} type="video/mp4" />
            Sorry, your browser does not support embedded videos.
          </video>
        ) : (
          <Image src="/gttl/lp_gtr_phone_bg.png" alt="iphone" />
        )}
      </div>
      <div className={clsx(css.textContainer)}>
        <Text
          as="h2"
          variant="h2"
          fontWeight="semibold"
          className="whitespace-pre-line text-center md:text-left"
        >
          {STRINGS['guaranteedTimeToLoveLanding.residentsTitle1']}
          <span className="text-green">
            {STRINGS['guaranteedTimeToLoveLanding.residentsTitle2']}
          </span>
        </Text>
        <Text
          variant="body"
          className="mt-xs md:mt-lg whitespace-pre-line text-center text-white md:whitespace-normal md:text-left"
        >
          {STRINGS['guaranteedTimeToLoveLanding.residentsSubtitle']}
        </Text>
        <div className="mt-lg flex w-full justify-center md:justify-start">
          <Link
            buttonType="primary"
            variant="solid"
            href={PATHS.HOMEOWNER_ONBOARDING_PROPERTY_ADDRESS}
            size="large"
          >
            {STRINGS['guaranteedTimeToLoveLanding.cta']}
          </Link>
        </div>
      </div>
    </div>
  );
}
